import { Checkbox } from '@pypestream/design-system';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { NodeColumns, tableStore } from '../../stores/table-store';

interface TableCellCheckboxProps {
  rowId: string;
  type?: React.HTMLInputTypeAttribute | undefined;
  minWidth?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columnId?: string | number | symbol | any;

  onChangeConversion?: (input: string) => unknown;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderValue?: (arg: any) => string;
  disabled?: boolean;
}

export const TableCellCheckbox: React.FC<TableCellCheckboxProps> = observer(
  ({
    rowId,
    columnId,
    minWidth = `calc(100% + 24px)`,
    onChangeConversion,
    renderValue,
    disabled,
    ...props
  }) => {
    const latestValueFromMobx = tableStore.getValue(rowId, columnId);
    const [inputValue, setInputValue] = useState(Boolean(latestValueFromMobx));
    const valueOnFocusRef = useRef<boolean>(Boolean(latestValueFromMobx));
    const index = tableStore.getRowIndex(rowId);

    useEffect(() => {
      if (inputValue === undefined) return;

      if (!tableStore.isCellBeingEdited && inputValue !== latestValueFromMobx) {
        setInputValue(Boolean(latestValueFromMobx));
      }
    }, [inputValue, latestValueFromMobx]);

    return (
      <Checkbox
        test-id={`c-editor-table--${columnId}-${index}-checkbox`}
        disabled={disabled || !tableStore.isEditing()}
        checked={inputValue}
        onfocus={() => {
          tableStore.isCellBeingEdited = true;
          valueOnFocusRef.current = Boolean(
            tableStore.getValue(rowId, columnId)
          );
        }}
        onblur={() => {
          setTimeout(() => {
            tableStore.isCellBeingEdited = false;
            const currentValue = Boolean(tableStore.getValue(rowId, columnId));
            if (currentValue !== valueOnFocusRef.current) {
              tableStore.clearCellValidationError(
                rowId,
                columnId as keyof typeof NodeColumns
              );
            }
          }, 100);
        }}
        onChange={(e) => {
          // if (e.target.checked === inputValue) return;

          setInputValue(e.target.checked);

          // Checkboxes should save immediately. Wrap in recordRowEdit so the
          // toggle is undoable (PSTUDIO-2154).
          tableStore.recordRowEdit(rowId, `Toggle ${String(columnId)}`, () => {
            tableStore.updateRow({
              rowId,
              updates: {
                [columnId]: e.target.checked,
              },
              skipValidationRules: false,
              saveImmediately: true,
            });
          });

          setTimeout(() => {
            tableStore.isCellBeingEdited = false;
          }, 100);
        }}
        size="small"
        {...props}
      />
    );
  }
);
